import type {
  FormattedNewWagerAttributes,
  FormattedNewWagerLineup
} from '@library/types/newWagers';
import { classNames } from '@library/utils';
import { formattedNewWagerDetails } from '@bo-utils/newWagers';

export interface MemberEntryCardHeaderProps {
  lineup: FormattedNewWagerLineup;
  newWager: FormattedNewWagerAttributes;
}

export const MemberEntryCardHeader = ({
  lineup,
  newWager
}: MemberEntryCardHeaderProps) => {
  const {
    amountBet,
    formattedGameMode,
    formattedResult,
    resultColor,
    resultHeader
  } = formattedNewWagerDetails(newWager, lineup);
  const { lineupGameType } = newWager;

  return (
    <div
      className="border-soFresh-140 flex items-center border-b p-4"
      data-testid="member-entry-card-header"
    >
      <div className="flex h-10 flex-col justify-between">
        <p className="text-soClean-100 font-semibold leading-none">
          <span>{resultHeader.text}</span>
          <span className={classNames('pl-1', resultHeader.color)}>
            {resultHeader.resultAmount}
          </span>
        </p>
        <p className="text-soClean-180 text-sm capitalize leading-none">
          {amountBet} {lineupGameType}
        </p>
      </div>
      <div className="ml-auto flex h-11 flex-col items-end justify-between">
        <span
          className={classNames(
            'border-soFresh-140 -mt-0.5 rounded border px-2 py-1 text-center text-xs font-semibold uppercase',
            resultColor
          )}
        >
          {formattedResult}
        </span>
        <p className="text-soClean-180 w-full text-center text-sm capitalize leading-none">
          {formattedGameMode}
        </p>
      </div>
    </div>
  );
};
